import angular from 'angular';

(function() {
    'use strict';
    angular.module('app').factory('CountrySvc', CountrySvc);

    CountrySvc.$inject = ['CountriesDA'];

    /* @ngInject */
    function CountrySvc(CountriesDA) {
        var _countries = null;

        var exports = {
            getAll: getAll
        };

        return exports;

        /**
         * Fournit une promesse sur la liste des pays.
         */
        function getAll() {
            if (!_countries) {
                _countries = CountriesDA.getAll();
            }
            return _countries;
        }
    }
})();
